// @ts-check
if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.productVariantDeselect = function () {
  /**
   * @var {HTMLElement}
   * the form that the user submits to add to basket (bag)
   */
  const form = document.querySelector("[data-product-form]");

  /** Check to see if a size has been selected but a variant does not exist in the URL. This forces a user to choose a size and not accidentally add the default XS size to their cart */
  const deselectIfNotChosen = () => {
    if (!form) {
      return;
    }

    const variantLength = form.querySelectorAll('[name="Size"]').length;
    const productSearchParams = new URLSearchParams(window.location.search);
    const hasVariantParam = productSearchParams.has("variant");

    if (variantLength > 1 && hasVariantParam === false) {
      form.querySelector('[name="Size"]:checked')?.removeAttribute("checked");
    }
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    if (!form) {
      return;
    }
    deselectIfNotChosen();
  };

  return {
    init,
  };
};

window.addEventListener("DOMContentLoaded", () => {
  window.AndDaughter.productVariantDeselect().init();
});
